import React from 'react';

import CoverSheet from '../general/coverSheet';
import PDFInfoSheet from '../../../themed/pdf/pdfInfoSheet';
import PDFPage from '../../../themed/pdf/pdfPage';
import VTPDFData from '../vt/vtPDFData';

import withPDF from '../../../hoc/withPDF';

import * as models from '../../../../utils/models';
import * as data from '../../../../utils/data';
import * as utils from '../../../../utils/utilities';

interface VTStructureReportProps {
	projectDetails: models.Project;
	vtSummaryData: models.VTStructureAnomalyData[];
	vtStructureReportSummary: string;
	coverSheetData: models.VTCoverData;
	photoRecord: models.PDFImageProps[];
}

const VTStructureReport = (props: VTStructureReportProps): JSX.Element => {
	const standardCriteriaItems: models.CoverDataItem[] = [
		{
			label: '1. Qualification of NDT Personnel',
			value: props.coverSheetData?.ndtQualification,
		},
		{
			label: '2. Non Destructive Testing',
			value: props.coverSheetData?.destructiveTesting,
		},
		{
			label: '3.  Process Piping Inspection Code',
			value: props.coverSheetData?.pipingInspectionCode,
		},
		{
			label: '4.  Process Piping Design',
			value: props.coverSheetData?.pipingDesign,
		},
		{
			label: '5.  Inspection of Piping System Component',
			value: props.coverSheetData?.pipingSystemComponent,
		},
		{
			label:
				'6.  Damage Mechanisms Affecting Fixed Equipment in the Refining Industry',
			value: props.coverSheetData?.damageMechanisms,
		},
	];

	const referenceDocuments: models.CoverDataItem[] = [
		{
			label: '1. Scope Of Work',
			value: props.coverSheetData?.scopeOfWork,
		},
		{
			label: '2. VT Procedure',
			value: props.coverSheetData?.vtProcedure,
		},
		{
			label: '3.  Rope Access Code of Practice',
			value: props.coverSheetData?.codeOfPractice,
		},
	];

	const pageSubtitle: string =
		'Document Number: ' + props.projectDetails.documentNumber;

	return (
		<React.Fragment>
			<PDFInfoSheet
				companyUrl={props.projectDetails.organisation.organisationLogo}
				documentNo={props.projectDetails.documentNumber}
				clientName={props.projectDetails.organisationName}
				facility={props.projectDetails.facilityName}
				reportTitle={props.projectDetails.projectTitle}
			/>

			<PDFPage
				pageDetails={utils.getPageDetails('Cover Sheet', pageSubtitle)}
				projectDetails={props.projectDetails}
			>
				<CoverSheet
					overviewData={overviewData}
					referenceDocuments={referenceDocuments}
					standardCriteriaItems={standardCriteriaItems}
				/>
			</PDFPage>

			<VTPDFData
				data={props.vtSummaryData}
				images={props.photoRecord}
				summary={props.vtStructureReportSummary}
				project={props.projectDetails}
			/>
		</React.Fragment>
	);
};

const overviewData: models.CoverDataOverview[] = data.getVTCoverOverview();
export default withPDF(VTStructureReport);
